import type { IconName } from '@customerio/pluma-icons';
import type { VideoCategory } from './types';

export const VIDEO_IDS = {
  ChooseYourPath: 'ruu5v5zh2x',
  UnderstandYourData: 'cviiflh34o',
  Segments: '4o6xjt5sgj',
  NewsletterABTest: 'd09td74x73',
  LiquidSyntax: 'jya6eciu2t',
  SendANewsletter: 'grg0vm5gql',
  ChooseAnEmailEditor: 'fo9njgwc65',
  CampaignMetrics: 'rl6mc0xjhj',
  CampaignMetricsWorkflows: '60r0tf34uq',
  ABHoldoutTests: 'j9fsby8qtv',
  MultiSplitBranching: 'sqxo20brke',
  RandomCohorts: 'nxshmk5k4s',
  TriggerOnSegmentChanges: 'qeib7lopt4',
  CampaignSettings: 'a1atd2kqjj',
  EventBasedGoal: 'n7pqx698kr',
  ExitConditions: 'bu9iwf2cb4',
  CreateFirstEmail: 'nvlrnhfo0w',
} as const;

// Video catalog with categories
export const VIDEOS: Array<{ id: string; category: VideoCategory }> = [
  { id: VIDEO_IDS.ChooseYourPath, category: 'Messaging' },
  { id: VIDEO_IDS.UnderstandYourData, category: 'People' },
  { id: VIDEO_IDS.Segments, category: 'Segments' },
  { id: VIDEO_IDS.NewsletterABTest, category: 'Analysis' },
  { id: VIDEO_IDS.LiquidSyntax, category: 'Messaging' },
  { id: VIDEO_IDS.SendANewsletter, category: 'Broadcasts' },
  { id: VIDEO_IDS.ChooseAnEmailEditor, category: 'Content' },
  { id: VIDEO_IDS.CampaignMetrics, category: 'Campaigns' },
  { id: VIDEO_IDS.CampaignMetricsWorkflows, category: 'Campaigns' },
  { id: VIDEO_IDS.ABHoldoutTests, category: 'Testing' },
  { id: VIDEO_IDS.MultiSplitBranching, category: 'Campaigns' },
  { id: VIDEO_IDS.RandomCohorts, category: 'Testing' },
  { id: VIDEO_IDS.TriggerOnSegmentChanges, category: 'Campaigns' },
  { id: VIDEO_IDS.CampaignSettings, category: 'Campaigns' },
  { id: VIDEO_IDS.EventBasedGoal, category: 'Campaigns' },
  { id: VIDEO_IDS.ExitConditions, category: 'Campaigns' },
  { id: VIDEO_IDS.CreateFirstEmail, category: 'Content' },
];

export const CATEGORY_ICONS: Record<VideoCategory, IconName> = {
  Campaigns: 'campaigns',
  People: 'person',
  Messaging: 'send-auto',
  Segments: 'segment',
  Analysis: 'chart',
  Content: 'email',
  Broadcasts: 'broadcast',
  Default: 'feature-launch',
  Testing: 'a-b-test',
};

export const WISTIA_STORAGE_PREFIX = 'wistia-video-progress-';
export const SEEK_DEBOUNCE_MS = 1000;
export const VIDEO_FINISHED_THRESHOLD = 0.9;
